import { defineStore } from "pinia";
import AuthApiService from "@/core/services/authApiService";
import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { setLocalStorageService } from "@/core/helpers/utility";
import { useEntityStore } from "./Entity";
import ConfirmEmail from "@/views/Auth/confirmEmail.vue";
const useEntity = useEntityStore();
export const useAuthStore = defineStore("auth", {
  state: () => ({
    errors: {},
    isAuthenticated: !!JwtService.getToken(),
    stateSubEntity: [],
    accessToken: localStorage.getItem("id_token") || null,
    refreshToken: localStorage.getItem("id_refresh_token") || null,
  }),
  getters: {
    user() {
      const authUser = localStorage.getItem("auth-user");
      if (!authUser) return {};
      return JSON.parse(authUser).profileInfo;
    },
  },
  actions: {
    setAuth(authUser) {
      this.isAuthenticated = true;
      this.errors = {};
      JwtService.saveToken(authUser.token);
      JwtService.saveRefreshToken(authUser?.refreshToken ?? "");
      AuthApiService.setAuthorizationHeader();
      this.setUser(authUser);
    },
    setError(error) {
      this.errors = { ...error };
    },
    purgeAuth() {
      localStorage.clear();
      this.isAuthenticated = false;
      this.errors = [];
      // JwtService.destroyToken();
    },
    _confirmEmail(credentials) {
      return AuthApiService.post("V2/account/confirmEmail", credentials)
        .then(({ data }) => {
          return data;
        })
        .catch((response) => {
          this.setError(response?.response?.data);
        });
    },
    getRefreshToken() {
      return AuthApiService.post("/account/refreshToken", {
        token: this.accessToken,
        refreshToken: this.refreshToken,
      })
        .then(({ data }) => {
          const newAccessToken = data.token;
          const newRefreshToken = data.refreshToken;
          this.accessToken = newAccessToken;
          this.refreshToken = newRefreshToken;
          window.localStorage.setItem("id_token", newAccessToken);
          window.localStorage.setItem("id_refresh_token", newRefreshToken);
          return newAccessToken;
        })
        .catch((response) => {
          this.setError(response?.response?.data);
        });
    },
    resolverLogin(credentials) {
      // "Account/resolver" master login
      return AuthApiService.post("Account/resolver", credentials)
        .then(({ data }) => {
          this.setAuth(data);

          return data;
        })
        .catch((response) => {
          this.setError(response?.response?.data);
        });
    },
    login(credentials) {
      // "Account/resolver" master login
      return AuthApiService.post("Account/login", credentials)
        .then(({ data }) => {
          this.setAuth(data);

          return data;
        })
        .catch((response) => {
          this.setError(response?.response?.data);
          return Promise.reject(response);
        });
    },
    logout() {
      this.purgeAuth();
    },
    register(credentials) {
      return AuthApiService.post("register", credentials)
        .then(({ data }) => {
          this.setAuth(data);
        })
        .catch(({ response }) => {
          this.setError(response.data);
        });
    },
    async getEntity() {
      return await ApiService.get(`v2/Entity/MyEntity`)
        .then((response) => {
          const result = response.data.data[0];
          useEntity.localEntity = [
            {
              entityType: result.entityType,
              entityId: result.id,
            },
          ];
          setLocalStorageService("sub-entity", [
            {
              entityType: result.entityType,
              entityId: result.id,
            },
          ]);
        })
        .catch(({ error }) => {
          throw error;
        });
    },
    forgotPassword(email) {
      return AuthApiService.post(`Account/ForgetPassword/${email}`)
        .then((response) => {
          this.setError();
          return response.data;
        })
        .catch(({ response }) => {
          this.setError(response.data.message);
          throw response;
        });
    },
    resetPassword(credentials) {
      return AuthApiService.post(`V2/Account/ResetPassword`, credentials)
        .then((response) => {
          this.setError();
          return response.data;
        })
        .catch(({ response }) => {
          this.setError(response.data.message);
          throw response;
        });
    },

    setUser(userDetails) {
      localStorage.setItem("auth-user", JSON.stringify(userDetails));
      localStorage.setItem("userId", JSON.stringify(userDetails.userId));
    },
  },
});
